import React from "react";
import { Link } from "react-router-dom";

const UserSidebar = ({ open }) => {
  return (
    <aside
      className={`bg-gray-800 text-white w-64 ${
        open ? "block" : "hidden"
      } md:block`}
    >
      <div className="p-4 font-bold text-lg border-b border-gray-700">
        User Panel
      </div>
      <nav className="p-4">
        <ul className="space-y-2">
          <li>
            <Link to="/" className="block py-2 px-3 rounded hover:bg-gray-700">
              Dashboard
            </Link>
          </li>
          <li>
            <Link
              to="/rides/ongoing"
              className="block py-2 px-3 rounded hover:bg-gray-700"
            >
              My Rides
            </Link>
          </li>
          <li>
            <Link
              to="/payments"
              className="block py-2 px-3 rounded hover:bg-gray-700"
            >
              Payments
            </Link>
          </li>
        </ul>
      </nav>
    </aside>
  );
};

export default UserSidebar;
